export default [
    {
        text: "ID",
        value: "uploadId"
    },
    {
        text: "Survey Date",
        value: "surveyDate"
    },
    {
        text: "Uploaded By",
        value: "userEmail",
        class: "wrap-headers"
    },
    {
        text: "Asset Id",
        value: "assetNo"
    },
    {
        text: "Address",
        value: "address"
    },
    {
        text: "Project Reference",
        value: "projectReference"
    },
    {
        text: "Type",
        value: "type"
    },
    {
        text: "Status",
        value: "status",
        tooltip:
            "<span>Pending - awaiting approval by authority<br>Approved - by authority awaiting processing<br>Processing - processing of survey data<br>Complete - reports and data available online</span>"
    },
    {
        text: "Purchase Order",
        value: "purchaseOrder"
    },
    {
        text: "Approved Date",
        value: "approvedDate"
    },
    {
        text: "",
        value: "checkbox",
        sortable: false
    }
];
